import { Facade } from '@/modules/budget/monitoring/input-forms/types/roots/Facade';
import { App9InputFormFacade } from '@/modules/budget/monitoring/input-forms/components/application9/App9Facade'
import { App12InputFormFacade } from '@/modules/budget/monitoring/input-forms/components/application12/App12Facade'
import { App19InputFormFacade } from '../components/application19/App19Facade';
import { App21InputFormFacade } from '@/modules/budget/monitoring/input-forms/components/application21/App21Facade'
import { App23InputFormFacade } from '../components/application23/App23Facade';
import { App26InputFormFacade } from '@/modules/budget/monitoring/input-forms/components/application26/App26Facade'
import { App41InputFormFacade } from '@/modules/budget/monitoring/input-forms/components/application41/App41Facade'

export class InputFormFacade {
    public getFacade(currForm: any): Facade | null {
        if (['app8', 'app8_ex', 'app9', 'app9_ex'].includes(currForm.form_code)) {
            return new App9InputFormFacade()
        } else if (['app12', 'app12cons', 'app14_rb', 'app14cons_rb', 'app14_ob', 'app14cons_ob', 'app18'].includes(currForm.form_code)) {
            return new App12InputFormFacade()
        } else if (['app19', 'app17', 'app15', 'app15', 'app13cons', 'app13_ob', 'app13_rn'].includes(currForm.form_code)) {
            return new App19InputFormFacade()
        } else if (['app21'].includes(currForm.form_code)) {
            return new App21InputFormFacade()
        } else if ('app23' === currForm.form_code) {
            return new App23InputFormFacade()
        } else if (['app26'].includes(currForm.form_code)) {
            return new App26InputFormFacade()
        } else if (['app41'].includes(currForm.form_code)) {
            return new App41InputFormFacade()
        }
        return null;
    }
}